module.exports = __webpack_public_path__ + "assets/fonts/information-circle.55a0bf41.svg";